import AllAppsCentre from './AllAppsCentre';

export default AllAppsCentre;